import { render, staticRenderFns } from "./restaurantDialog.vue?vue&type=template&id=87d3be8c&scoped=true&"
import script from "./restaurantDialog.vue?vue&type=script&lang=js&"
export * from "./restaurantDialog.vue?vue&type=script&lang=js&"
import style0 from "./restaurantDialog.vue?vue&type=style&index=0&id=87d3be8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d3be8c",
  null
  
)

export default component.exports